import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import HeroSection from "./components/HeroSection";
import BrowseBySpace from "./components/BrowseBySpace";
import FeaturedInspiration from "./components/FeaturedInspiration";
import PopularSpaces from "./components/PopularSpaces";
import NewsletterSection from "./components/NewsletterSection";
import FooterCTA from "./components/FooterCTA";

export default function Home() {
  return (
    <div className="bg-[#FAF7F0]">
      <Navbar />
      <HeroSection />
      <BrowseBySpace />
      <FeaturedInspiration />
      <PopularSpaces />
      <NewsletterSection />
      <FooterCTA />
      <Footer />
    </div>
  );
}
